import './filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.BooleanFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST['backbone/templates/monitoring/filters/boolean_filter']

  initialize: ({searchQuery, title, trueField, falseField}) ->
    @searchQuery = notNull(searchQuery)
    @title = notNull(title)
    @trueField = notNull(trueField)
    @falseField = notNull(falseField)

  render: ->
    unless @searchQuery.get(@trueField.getName()) || @searchQuery.get(@falseField.getName()) || @mustHide()
      @$el.html(@template(
        searchQuery: @searchQuery
        title: @title
        trueFieldTitle: @trueField.getTitle()
        falseFieldTitle: @falseField.getTitle()
      ))
    @

  apply: (event) =>
    @searchQuery.set(@trueField.getName(), @$el.find('#true').get(0).checked)
    @searchQuery.set(@falseField.getName(), @$el.find('#false').get(0).checked)
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
